import React from 'react'

interface SliderProps {
  cards: any[]
  variant: 'primary' | 'white'
}

const Slider: React.FC<SliderProps> = ({ cards, variant = 'primary' }) => {
  const buttonClass = variant === 'primary' ? 'Slider__primaryButton' : 'Slider__whiteButton'
  return (
    <div className='Slider'>
      {cards.map((_: any, i: number) => {
        return (
          <span
            key={i}
            className={buttonClass}
            data-platinum-carousel-target='carouselButtons'
            data-vanilla-carousel-nav-button-active={i === 0}
          />
        )
      })}
    </div>
  )
}

export default Slider
